import React from 'react';
import Link from '../link';

const SitemapContainer: React.FC = () => (
  <section>
    <div className="map-section">
      <h3>
        <Link href="/bookstore">
          <a>Bookstore</a>
        </Link>
      </h3>
      <ul>
        <li>
          <Link href="/owners">
            <a>Owner Literature</a>
          </Link>
        </li>
        <li>
          <Link href="/parts">
            <a>Service Parts/Literature</a>
          </Link>
        </li>
        <li>
          <Link href="/training">
            <a>Training Materials</a>
          </Link>
        </li>
      </ul>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/contact-us">
          <a>Contact us</a>
        </Link>
      </h3>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/knowledgebase">
          <a>Knowledgebase</a>
        </Link>
      </h3>
    </div>
    <div className="map-section">
      <h3>Legal</h3>
      <ul>
        <li>
          <Link href="/legal/privacy">
            <a>Privacy</a>
          </Link>
        </li>
      </ul>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/new-users">
          <a>New Users</a>
        </Link>
      </h3>
      <ul>
        <li>
          <Link href="/new-users/credit-card">
            <a>Credit Card</a>
          </Link>
        </li>
        <li>
          <Link href="/new-users/how-to/creating-an-account">
            <a>Creating an Account</a>
          </Link>
        </li>
        <li>
          <Link href="/new-users/how-to/general-site-navigation">
            <a>General Site Navigation</a>
          </Link>
        </li>
        <li>
          <Link href="/new-users/how-to/ordering-from-the-site">
            <a>Ordering from the Site</a>
          </Link>
        </li>
        <li>
          <Link href="/new-users/how-to/submitting-a-help-request">
            <a>Submitting a Help Request</a>
          </Link>
        </li>
        <li>
          <Link href="/new-users/how-to/workshop-library-and-subscriptions">
            <a>Workshop Library and Subscriptions</a>
          </Link>
        </li>
      </ul>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/resources">
          <a>Resources</a>
        </Link>
      </h3>
      <ul>
        <li>
          <Link href="/resources/child-safety-information">
            <a>Child Safety Information</a>
          </Link>
        </li>
        <li>
          <Link href="/resources/mode-06">
            <a>Mode 06</a>
          </Link>
        </li>
        <li>
          <Link href="/resources/vin-decoder">
            <a>VIN Decoder</a>
          </Link>
        </li>
        <li>
          <Link href="/resources/information-notice">
            <a>Information Notice</a>
          </Link>
        </li>
        <li>
          <Link href="/resources/vehicle-extrication-guide">
            <a>Vehicle Extrication Guide</a>
          </Link>
        </li>
        <li>
          <Link href="/resources/workshop-support-platform">
            <a>Workshop Support Platform</a>
          </Link>
        </li>
      </ul>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/vehicle-emergency-response">
          <a>Vehicle Emergency Response</a>
        </Link>
      </h3>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/vida">
          <a>VIDA</a>
        </Link>
      </h3>
      <ul>
        <li>
          <Link href="/vida/computer-requirements">
            <a>Computer Requirements</a>
          </Link>
        </li>
        <li>
          <Link href="/vida/purchase">
            <a>Purchase</a>
          </Link>
        </li>
      </ul>
    </div>
    <div className="map-section">
      <h3>
        <Link href="/wholesale-parts-hub">
          <a>Wholesale Parts Hub</a>
        </Link>
      </h3>
      <ul>
        <li>
          <Link href="/wholesale-parts-hub/certified-collision">
            <a>Certified Collision</a>
          </Link>
        </li>
        <li>
          <Link href="/wholesale-parts-hub/parts-ordering">
            <a>Parts Ordering</a>
          </Link>
        </li>
        <li>
          <Link href="/wholesale-parts-hub/parts-overview">
            <a>Parts Overview</a>
          </Link>
        </li>
      </ul>
    </div>
    {/* language=CSS */}
    <style jsx>{`
      .map-section {
        padding-bottom: 2rem;
      }

      .map-section h3,
      .map-section h3 a {
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 400;
        padding: 0;
        margin: 0 0 1rem;
        font-size: 20px;
        text-decoration: none;
        cursor: pointer;
        color: #333;
      }

      .map-section ul {
        margin: 0;
        padding: 0 0 0 1rem;
        list-style: none;
      }

      .map-section a {
        font-family: 'Volvo Novum', sans-serif;
        font-weight: 300;
        font-size: 14px;
        color: #333;
        text-decoration: none;
      }

      .map-section a:hover {
        color: #707070;
      }
    `}</style>
  </section>
);

export default SitemapContainer;
